export default [{
    path: '/potentialSupplierManageList',
    name: 'potentialSupplierManageList',
    component: () =>
        import('@/components/page/supplierManage/potentialSupplierManageList'),
    meta: { title: 'supplierManage.potentialSupplierManage' },
},
{
    path: '/potentialSupplierManageList-detail',
    name: 'potentialSupplierManageDetail',
    component: () =>
        import('@/components/page/supplierManage/potentialSupplierManageDetail'),
    meta: { title: 'supplierManage.potentialSupplierInfoRegister' },
},
{
    path: '/potentialSupplierManageList-detail/view',
    name: 'potentialSupplierManageDetail',
    component: () =>
        import('@/components/page/supplierManage/potentialSupplierManageView'),
    meta: { title: 'supplierManage.potentialSupplierInfoRegister' },
},
{
    path: '/supplierResourceManageList',
    name: 'supplierResourceManageList',
    component: () =>
        import('@/components/page/supplierManage/supplierResourceManageList'),
    meta: { title: 'supplierManage.supplierResourceManage' },
},
{
    path: '/supplierResourceManageList-detail',
    component: () =>
        import('@/components/page/supplierManage/supplierResourceManageDetail'),
    meta: { title: '资源管理详情' },
},
{
    path: '/supplierResourceManageList-detail/view',
    component: () =>
        import('@/components/page/supplierManage/supplierResourceManageView'),
    meta: { title: '资源管理详情' },
},
{ //潜在供应商详审批
    path: '/supplierApproval',
    component: () =>
        import('@/components/page/supplierManage/supplierApproval'),
    meta: { title: 'supplierManage.potentialSupplierInfoRegister' },
},

]